import { SUPABASE_ANON_KEY, SUPABASE_URL, adminApi, getAccessToken, publicApi } from "./supabase";

const MEDIA_KIT_FUNCTION_URL =
  process.env.REACT_APP_MEDIA_KIT_FUNCTION_URL ||
  `${SUPABASE_URL}/functions/v1/media-kit-refresh`;

function numberOrNull(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function normalizeCountries(value) {
  if (!Array.isArray(value)) return [];
  return value
    .map((country) => ({
      code: String(country.code || "").toUpperCase(),
      name: String(country.name || country.code || ""),
      percent: numberOrNull(country.percent),
    }))
    .filter((country) => country.code && country.percent !== null);
}

export function normalizeMediaKitStat(row) {
  return {
    platform: row.platform,
    followersCount: numberOrNull(row.followers_count),
    views28d: numberOrNull(row.views_28d),
    discoveryPercent: numberOrNull(row.discovery_percent),
    femalePercent: numberOrNull(row.female_percent),
    age1844Percent: numberOrNull(row.age_18_44_percent),
    countries: normalizeCountries(row.countries),
    periodStart: row.period_start,
    periodEnd: row.period_end,
    capturedAt: row.captured_at,
    source: row.source,
  };
}

export async function fetchMediaKitStats() {
  const rows = await publicApi("media_kit_platform_stats?select=*&order=platform");
  return rows.map(normalizeMediaKitStat);
}

export async function fetchAdminMediaKitStats() {
  const rows = await adminApi("media_kit_platform_stats?select=*&order=platform");
  return rows.map(normalizeMediaKitStat);
}

export async function updateTikTokMediaKitStats(values) {
  const rows = await adminApi("media_kit_platform_stats?platform=eq.tiktok", {
    method: "PATCH",
    headers: { Prefer: "return=representation" },
    body: JSON.stringify({
      followers_count: numberOrNull(values.followersCount),
      views_28d: numberOrNull(values.views28d),
      discovery_percent: numberOrNull(values.discoveryPercent),
      female_percent: numberOrNull(values.femalePercent),
      age_18_44_percent: numberOrNull(values.age1844Percent),
      countries: normalizeCountries(values.countries),
      period_start: values.periodStart || null,
      period_end: values.periodEnd || null,
      captured_at: new Date().toISOString(),
      source: "manual",
    }),
  });
  if (!rows[0]) throw new Error("TikTok media-kit data could not be updated.");
  return normalizeMediaKitStat(rows[0]);
}

export async function refreshAutomaticMediaKitStats() {
  const accessToken = await getAccessToken();
  const response = await fetch(MEDIA_KIT_FUNCTION_URL, {
    method: "POST",
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: "{}",
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || "Automatic social statistics could not be refreshed.");
  return body;
}
